export const filter = {
    id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
